import React from "react";
import { useParams } from "react-router-dom";
import ProjectTabs from "../components/ProjectTabs";

const ProjectOffer = () => {
  const { projectId } = useParams();

  return (
    <div>
      <ProjectTabs active="offer" />
      <h2>Offer for project {projectId}</h2>
      {/* ovde dodaješ sadržaj ponude */}
    </div>
  );
};

export default ProjectOffer;
